import React from 'react';
import styled from 'styled-components';

import {Trans} from '../../../../../libs/shared/core/src/helpers/internationalization/react';
import {Icon} from '../../../../../libs/shared/ui/src/components/icon/icon';
import {TooltipCoordinator} from '../../../../../libs/shared/ui/src/components/tooltips/tooltipCoordinator';
import {useUserTheme} from '../../../../../libs/shared/ui/src/theme/userThemeProvider';

/*
 * Styles.
 */

const StyledIconContainer = styled.div`
  padding: 3px;
`;

/*
 * Component.
 */

export const WorkspacesHeaderOfflineIcon = () => {
  const theme = useUserTheme();

  return (
    <TooltipCoordinator
      render={() => <Trans id="workspace-header-offline-tooltip">Not available while offline</Trans>}
    >
      <StyledIconContainer>
        <Icon name="offlineFilledSmall" color={theme.leftBar.headerMore} />
      </StyledIconContainer>
    </TooltipCoordinator>
  );
};
